import { JokyoKb, NyukyoStatus } from "src/extensions/utils/DefineTypes";
/** 状況区分が3：入居中か判断 */
export function isMoveIn(jokyoKb) {
    return jokyoKb === JokyoKb.MoveIn;
}
/** 退去解約申請ステータスが0：入居中か判断 */
export function isCurrentlyMovingIn(status) {
    return status === NyukyoStatus.CurrentlyMovingIn;
}
